var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsSpread = function SvgMetricsSpread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.85 9.151 24 3 9.151 9.151 3.001 24l6.15 14.849L24 45l14.849-6.15L45 24zM24 31.633c-6.944 0-13.49-2.836-17.725-7.633C10.51 19.203 17.056 16.368 24 16.368S37.49 19.203 41.726 24C37.49 28.797 30.944 31.633 24 31.633"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 6.559
  })))));
};
export default SvgMetricsSpread;